<script lang="ts">
  import ChannelListEditor from "../../components/Business/ChannelListEditor.svelte";
  import { addChannel, channels, delChannel, record } from "./lead.store";
</script>

{#if $record}
  <ChannelListEditor
    entityId={$record.oid}
    channels={$channels}
    on:save={addChannel}
    on:delete={delChannel}
  />
{/if}

